export default "__VITE_ASSET__uW2t3cOF__"